export default __webpack_public_path__ + "static/media/logo-2.d61d95c3.jpg";